export const getAddDealerFields = (t: (key: string) => string) => [
  {
    name: "dealerName",
    label: t(`dealers.DealerName`),
    type: "text",
    required: true,
  },
  {
    name: "code",
    label: t(`dealers.code`),
    type: "text",
    required: true,
  },
  {
    name: "inn",
    label: t(`dealers.inn`),
    type: "text",
    required: true,
  },
];
